const reservedTags = [
  'severityhigh',
  'severitymedium',
  'severitylow',
  'lowrelevance',
  'falsepositive',
  'sensitivedisclosure',
  'discussions',
  'blackmarkets',
  'financialinformation',
  'exposedcredentials',
  'personalinformation',
  'hackergrouptargeting',
  'attacksandcompromises',
  'unidentified',
  'deepweb',
  'darkweb',
  'databreach'
]

const severityTags = [
  'severityhigh',
  'severitymedium',
  'severitylow',
  'lowrelevance',
  'falsepositive'
]

const categoryTags = [
  'sensitivedisclosure',
  'discussions',
  'blackmarkets',
  'financialinformation',
  'exposedcredentials',
  'personalinformation',
  'hackergrouptargeting',
  'attacksandcompromises',
  'unidentified'
]

const sourceTags = [
  'deepweb',
  'darkweb',
  'databreach'
]

export default {
    reserved: reservedTags,
    severity: severityTags,
    category: categoryTags,
    source: sourceTags
}
